/**
 * Key values (baseline / latest / target) display helpers.
 */

export function hasKeyFigure(point) {
  if (!point || typeof point !== 'object') return false;
  const y = point.year;
  return y !== null && y !== undefined && y !== '' && !Number.isNaN(Number(y));
}

export function formatKeyFigureDisplay(point, isBinary) {
  if (!hasKeyFigure(point)) return null;
  if (isBinary && point.value != null && !Number.isNaN(Number(point.value))) {
    const yn = Number(point.value) >= 0.5 ? 'Yes' : 'No';
    return `${yn} (${point.year})`;
  }
  return String(point.year);
}

export function shouldShowKeyValuesSection(computed) {
  if (!computed) return false;
  const hasTarget =
    computed.target &&
    computed.target.value != null &&
    computed.target.value !== '';
  return hasKeyFigure(computed.baseline) || hasKeyFigure(computed.latest) || hasTarget;
}
